import * as React from 'react';
import {animated, useSpring, useTransition} from 'react-spring';
import {isIe} from '../../services/env/isIe';
import {GlobalLoader} from '../GlobalLoader';
import styles from './HideLoading.scss';
import {IOuter} from './HideLoading.types';

export const HideLoading: React.FunctionComponent<IOuter> = ({children, isLoading, noAnimation = isIe()}) => {
  const show = !isLoading;

  const contentProps = useSpring({
    from: {
      opacity: show ? 1 : 0,
      display: show ? 'block' : 'none',
    },
    to: {
      delay: 100,
      display: show ? 'block' : 'none',
      opacity: show ? 1 : 0,
      transform: show ? 'translateY(0)' : 'translateY(200px)',
    },
  });

  const transitions = useTransition(!show, null, {
    from: {opacity: show ? 1 : 0},
    enter: {opacity: 1},
    leave: {opacity: 0},
  });

  if (noAnimation) {
    return (
      <div className={styles.hideLoadingNoAnimation}>
        <div style={isLoading ? {visibility: 'hidden'} : {}} data-hook="loader-content" aria-hidden={isLoading}>
          {children}
        </div>
        {isLoading && (
          <div className={styles.loaderNoAnimation}>
            <GlobalLoader />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.hideLoading}>
      <animated.div key="content" style={contentProps} data-hook="loader-content" aria-hidden={isLoading}>
        {children}
      </animated.div>
      {transitions.map(
        ({item, key, props}) =>
          item && (
            <animated.div key={key} style={props} className={styles.loader}>
              <GlobalLoader />
            </animated.div>
          ),
      )}
    </div>
  );
};

HideLoading.displayName = 'HideLoading';
